import { useState } from 'react';
import classNames from 'classnames';

import { Image } from '../../Image/Image';

import type { FC } from 'react';
import type { ImageSources } from '../../../helpers/images';

import * as styles from './AssetImage.module.scss';

interface Props {
  className?: string;
  imageSources: ImageSources;
}

export const AssetImage: FC<Props> = ({ className, imageSources }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <Image
      className={classNames(className, styles.image, {
        [styles.isLoaded]: isLoaded,
      })}
      imageSources={imageSources}
      isRounded={false}
      onLoad={() => setIsLoaded(true)}
      lazy={false}
    />
  );
};
